import { render } from "./HeaderLayout.vue?vue&type=template&id=c47c26cc"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/instructor/HeaderLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c47c26cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c47c26cc', __exports__)) {
    api.reload('c47c26cc', __exports__)
  }
  
  module.hot.accept("./HeaderLayout.vue?vue&type=template&id=c47c26cc", () => {
    api.rerender('c47c26cc', render)
  })

}


export default __exports__